import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=4aaffd9a&scoped=true"
import script from "./index.page.vue?vue&type=script&lang=ts"
export * from "./index.page.vue?vue&type=script&lang=ts"
import style0 from "./index.page.vue?vue&type=style&index=0&id=4aaffd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaffd9a",
  null
  
)

export default component.exports